import React, { FC } from 'react';
import { Setting, Settings } from '../../../scripts/settings';
import Toggle from '../../common/toggle/Toggle';

import './SettingsPicker.scss';

interface IProps {
    setting: Setting
    update: (newSetting: Setting) => void;
}

const SettingsPicker: FC<IProps> = (props) => {
    const { setting, update } = props


    if (setting._type === "boolean") {

        const onChange = (newVal: boolean) => {
            update({
                _type: "boolean",
                _name: setting._name,
                value: newVal
            })
        }

        return <div className="settingRow">
            <Toggle currentValue={setting.value} setter={onChange}>
                {Settings.settingDescriptions[setting._name]}
            </Toggle>
        </div>
    }

    return <div className='SettingRow'>
        Setting {setting._name} not supported
    </div>
}

export default SettingsPicker;